// src/icons/svgs/align-text-center.svg
import * as React from "react";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var SvgAlignTextCenter = (props, ref) => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 18, fill: "none", viewBox: "0 0 24 18", ref, ...props, children: /* @__PURE__ */ jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M1.364.818a.818.818 0 1 0 0 1.636h21.329a.818.818 0 1 0 0-1.636zm3.555 4.91a.818.818 0 1 0 0 1.636h14.22a.818.818 0 1 0 0-1.637zM.546 11.454c0-.452.366-.819.818-.819h21.329a.818.818 0 1 1 0 1.637H1.363a.82.82 0 0 1-.817-.819m4.373 4.09a.818.818 0 1 0 0 1.637h14.22a.818.818 0 0 0 0-1.637z", clipRule: "evenodd" }) });
var ForwardRef = forwardRef(SvgAlignTextCenter);
var align_text_center_default = ForwardRef;
export {
  align_text_center_default as TextAlignCenter
};
